import React from 'react';
import '../../../styles/components/doctor/onboarding_layout.css';
import logo2 from '../../../assets/images/NeurolexLogo_White.png';

const OnboardingLayout = ({ children, currentStep = 1, totalSteps = 3, canSkip = true }) => {


  return (
    <div className="onboarding-layout">
      <div className="onboarding-columns">
        {/* Left column - Form content */}
        <div className="onboarding-form-column">
          {/* Header with logo and progress */}
          {/* Main content */}
          <div className="onboarding-content">
            {children}
          </div>
        </div>
        
        {/* Right column - Decorative content */}
        <div className="onboarding-decorative-column">
          <img src={logo2} alt="Neurolex Logo" className="onboarding-logo2" />
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;